"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatTime(seconds) {
    var isValid = !isNaN(seconds) && isFinite(seconds);
    var isNegative = isValid && seconds < 0;
    var date = new Date(null);
    date.setSeconds(isValid ? Math.abs(Math.floor(seconds)) : 0);
    // get HH:mm:ss part, remove hours if they are "00:"
    var time = date
        .toISOString()
        .substr(11, 8)
        .replace(/^00:/, '');
    return isNegative ? "-" + time : time;
}
exports.default = formatTime;
//# sourceMappingURL=formatTime.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/utils/formatTime.js
// module id = 27
// module chunks = 0